import {ContentBase} from "../components/surveyModal";
import {TitleHL} from "../../typography";
import Confirmation from "../components/confirmation";

export function ConfirmationPage({onClose, onConfirm, page}) {
    return <ContentBase>
        <TitleHL style={{whiteSpace: 'pre-wrap', fontWeight: 'bold'}}>{page.text}</TitleHL>
        <Confirmation onClickNeg={onClose} onClickPos={onConfirm}/>
    </ContentBase>
}